import { json, http } from "utils/http/client";

export const SupportTicketApi = {
    /**
     * Create a new support ticket
     * POST /org/create/ticket/
     * @param {FormData} formData - Form data containing org, category, priority, issue_header, issue_description, and optional attachments
     */
    createTicket: (formData) =>
        http("/org/create/ticket/", {
            method: "POST",
            body: formData,
        }).then(res => res.json()),

    /**
     * Get all tickets for an organization
     * GET /org/get/ticket/{orgId}/
     * @param {number} orgId - Organization ID
     */
    getTickets: (orgId) =>
        json(`/org/get/ticket/${orgId}/`, {
            method: "GET",
        }),
};
